// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgScienceVirusSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.453 3.259c.349-1.679 2.745-1.679 3.095 0l.22 1.059a1.58 1.58 0 0 0 2.414 1l.905-.593c1.434-.94 3.128.755 2.188 2.188l-.593.905a1.58 1.58 0 0 0 1 2.414l1.06.22c1.678.35 1.678 2.746 0 3.095l-1.06.221a1.58 1.58 0 0 0-1 2.414l.593.905c.94 1.434-.755 3.128-2.188 2.188l-.905-.593a1.58 1.58 0 0 0-2.414 1l-.22 1.06c-.35 1.678-2.746 1.678-3.095 0l-.221-1.06a1.58 1.58 0 0 0-2.414-1l-.905.593c-1.433.94-3.128-.755-2.188-2.188l.593-.905a1.58 1.58 0 0 0-1-2.414l-1.06-.22c-1.678-.35-1.678-2.746 0-3.096l1.06-.22a1.58 1.58 0 0 0 1-2.414l-.593-.905c-.94-1.433.755-3.128 2.188-2.188l.905.593a1.58 1.58 0 0 0 2.414-1zM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm3.5-7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgScienceVirusSolid;
